import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative min-h-[480px] overflow-hidden bg-black md:min-h-[560px] lg:min-h-0">
      {/* Full-bleed video background */}
      <div className="absolute inset-0 z-0">
        <video
          className="absolute inset-0 h-full w-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          aria-hidden
        >
          <source src={`${process.env.PUBLIC_URL ?? ''}/cloud9-hero.mp4`} type="video/mp4" />
        </video>
        {/* Readability: darken + slight gradient */}
        <div
          className="absolute inset-0 bg-black/55"
          aria-hidden
        />
        <div
          className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/50"
          aria-hidden
        />
      </div>

      {/* Extra bottom padding clears the decorative wave (~120/1440 of viewport width tall) */}
      <div className="container relative z-10 mx-auto px-4 pt-12 pb-40 md:pt-20 md:pb-44 lg:pb-52 xl:pb-56 2xl:pb-64">
        <div className="mx-auto max-w-4xl text-center">
          <h1 className="mb-4 text-3xl font-bold leading-tight text-white drop-shadow-md md:mb-6 md:text-5xl lg:text-6xl">
            The Hamptons&apos; Premier
            <span className="mt-2 block bg-gradient-to-r from-green-400 to-emerald-300 bg-clip-text text-transparent drop-shadow-sm">
              Cannabis Delivery Service
            </span>
          </h1>

          <p className="mb-3 text-lg text-neutral-100 drop-shadow md:text-xl lg:text-2xl">
            Serving Southampton, East Hampton, Montauk &amp; Beyond
          </p>

          <p className="mx-auto mb-6 max-w-2xl text-base text-neutral-200 drop-shadow md:mb-8 md:text-lg lg:text-xl">
            Fast same-day delivery throughout The Hamptons
          </p>

          <div className="mb-6 flex flex-col items-center justify-center gap-3 px-4 sm:flex-row md:mb-8 md:gap-4">
            <a href="#shop" className="w-full sm:w-auto">
              <Button
                size="lg"
                className="w-full transform bg-green-500 px-6 py-5 text-base font-semibold text-white shadow-xl transition-all duration-300 hover:scale-105 hover:bg-green-600 hover:shadow-2xl md:px-8 md:py-6 md:text-lg"
              >
                Shop Now
                <ArrowRight className="ml-2 h-4 w-4 md:h-5 md:w-5" />
              </Button>
            </a>
            <a href="#shop" className="w-full sm:w-auto">
              <Button
                size="lg"
                variant="outline"
                className="w-full border-2 border-white bg-black/20 px-6 py-5 text-base font-semibold text-white backdrop-blur-sm transition-all duration-300 hover:bg-white hover:text-black md:px-8 md:py-6 md:text-lg"
              >
                Browse All Products
              </Button>
            </a>
          </div>

          <div className="inline-block rounded-full border border-white/25 bg-black/45 px-4 py-2 text-sm font-semibold text-white shadow-lg backdrop-blur-md md:px-6 md:py-3 md:text-base">
            🌿 Premium Cannabis Delivered to Your Door
          </div>
        </div>
      </div>

      {/* Decorative bottom wave — z below content so copy/buttons aren’t covered */}
      <div className="pointer-events-none absolute bottom-0 left-0 right-0 z-[1]">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
          <path
            d="M0 120L60 105C120 90 240 60 360 45C480 30 600 30 720 37.5C840 45 960 60 1080 67.5C1200 75 1320 75 1380 75L1440 75V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z"
            fill="white"
          />
        </svg>
      </div>
    </section>
  );
};

export default Hero;
